import Controller from '@ember/controller';

export default class IndexController extends Controller {
  get randomSalutation() {
    const random = Math.floor(Math.random() * 5) + 1;
    return `index.hello-small-${random}`;
  }
}

